import React, {Component} from 'react';

class ZkWxClient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            avatar: '',//头图
            nickname: '',//微信昵称
            corpName: '',//企业
            friendType: '',
        }
    }

    render() {
        const {avatar, nickname, corpName, friendType} = this.props
        return (
            <>
                {
                    nickname || avatar ? <div className={'single_info'}>
                        <img src={avatar} style={{width: '38px', height: '38px'}}/>
                        <span style={{display: 'flex', flexDirection: 'column'}}>
                                   <span className='friendName' style={{minWidth: '90px'}}>
                                       {nickname}
                                   </span>
                            {
                                corpName ?
                                    <label
                                        style={{color: corpName == '微信' ? '#33BA44' : '#FE9500'}}
                                        className={friendType == 0 ? 'wxFriend' : 'qywxFriend'}>
                                        @{corpName}
                                    </label> : ''
                            }

                                </span>

                    </div> : '--'
                }
            </>
        );
    }
}

export default ZkWxClient;